var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"theme-box",attrs:{"title":_vm.title}},[_c('div',{staticClass:"theme-title"},[_c('h6',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.number)+". "+_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@assets/img/right-arrow-bi.svg"),"width":"20px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }